"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Refund = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.5,3 C16.7467051,3 21,7.25329488 21,12.5 C21,17.7467051 16.7467051,22 11.5,22 C6.76369635,22 2.8369254,18.5339785 2.11775173,14 L3.13193315,14 C3.84039965,17.9790164 7.31740556,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C8.05329052,4 5.08572869,6.05147494 3.75173932,9 L7,9 L7,10 L2,10 L2,5 L3,5 L3,8.25270378 C4.55928014,5.13822344 7.77993565,3 11.5,3 Z M9,14 L10,14 C10,14.5522847 10.4477153,15 11,15 L12,15 C12.5522847,15 13,14.5522847 13,14 C13,13.4477153 12.5522847,13 12,13 L11,13 C9.8954305,13 9,12.1045695 9,11 C9,9.8954305 9.8954305,9 11,9 L11,8 L12,8 L12,9 C13.1045695,9 14,9.8954305 14,11 L13,11 C13,10.4477153 12.5522847,10 12,10 L11,10 C10.4477153,10 10,10.4477153 10,11 C10,11.5522847 10.4477153,12 11,12 L12,12 C13.1045695,12 14,12.8954305 14,14 C14,15.1045695 13.1045695,16 12,16 L12,17 L11,17 L11,16 C9.8954305,16 9,15.1045695 9,14 Z" })));
};
Refund.displayName = 'Refund';
exports.default = Refund;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Refund.js.map